export const getTranslation = (data: any, key: string): string | null => {
  return key.split(".").reduce((obj, part) => {
    if (obj === null || typeof obj !== "object") return null;
    if (part in obj) {
      return obj[part];
    } else {
      return null;
    }
  }, data);
};
